import { useState } from "react";
import { IconButton, Modal } from "src/Components";
import { Input } from "src/Components/Controls";
import { SelectBox } from "src/UI";
import { IModalProps } from "..";
import "./ReturnCancelCallModal.scss";

const OTHER_REASON = "other";

const cancelReasons: Array<{ id: string; title: string }> = [
	{ id: "not-appear", title: "Заявитель не явился в установленное время" },
	{ id: "visitor-refused", title: "Посетитель отказался от обслуживания" },
	{ id: "invalid-ticket", title: "Талон вызван ошибочно" },
	{ id: "duplicate-call", title: "Посетитель уже обслужен в другом окне" },
	{ id: "cannot-identify", title: "Не удалось идентифицировать посетителя" },
	{ id: OTHER_REASON, title: "Другая причина" }
];

const ReturnCancelCallModal: React.FC<IModalProps> = ({ isOpen, onClose, onAction }) => {
	const [ reason, setReason ] = useState<string>(cancelReasons[0].id);
	const [ otherReason, setOtherReason ] = useState<string>("");
	const isOtherReason = reason === OTHER_REASON;
	const selectedReason = cancelReasons.find(item => item.id === reason)?.title || "";
	const resolvedReason = isOtherReason ? otherReason.trim() : selectedReason;

	const handleReasonChange = (value: string) => {
		setReason(value);
		if (value !== OTHER_REASON) setOtherReason("");
	};

	const renderBody: React.FC = () => (
		<div className="return-cancel-call-modal__body">
			<label className="return-cancel-call-modal__label">
				Причина отказа <span>*</span>
			</label>
			<SelectBox
				options={cancelReasons}
				selectedValues={reason ? [reason] : []}
				onChangeSelected={(items) => handleReasonChange(items[0]?.id ?? "")}
				placeholder="Выберите причину отказа"
				allowClear
			/>
			{isOtherReason && (
				<>
					<label className="return-cancel-call-modal__label">
						Другая причина отказа <span>*</span>
					</label>
					<Input
						value={otherReason}
						onChangeValue={setOtherReason}
						className="return-cancel-call-modal__input"
					/>
				</>
			)}
		</div>
	);

	return (
		<Modal
			isOpen={isOpen}
			title="Отказ от вызова посетителя"
			titleType="small"
			onClose={onClose}
			color="light"
			className="return-cancel-call-modal"
			renderBody={renderBody}
			renderFooter={(
				<>
					<IconButton color="red" outline onClick={onClose}>Отмена</IconButton>
					<IconButton color="green" disable={!resolvedReason} onClick={() => onAction("return-stop-call-confirm", resolvedReason)}>
						Отказаться от вызова
					</IconButton>
				</>
			)}
		/>
	);
};

export default ReturnCancelCallModal;
